import { combineReducers } from 'redux';
import currentUser from './current-user-reducer';

const userDetailsReducer = combineReducers({
  currentUser,
});

export default userDetailsReducer;
